export default "__VITE_ASSET__8812dbf6__"